import { Component } from '@angular/core'
import { SeFeTab } from 'se-fe-tabs'

@Component({
  selector: 'app-open-registration',
  templateUrl: './open-registration.component.html',
  standalone: false,
})
export class OpenRegistrationComponent {
  public tabs: SeFeTab[] = [
    { routerLink: '/user/registrations/open', text: 'Open registrations' },
    { routerLink: '/user/registrations/completed', text: 'Completed registrations' },
  ]
}

@Component({
  selector: 'app-registration-tab-placeholder',
  template: '',
  standalone: false,
})
export class RegistrationTabPlaceholderComponent {}
